import apiClient from './client';

export type AttendanceStatus = 'present' | 'late' | 'excused' | 'absent';

export interface PlanterTrainingSession {
  id: number;
  displayTitle: string;
  module: string;
  part: number | null;
  title: string;
  startsAt: string;
  endsAt: string;
  timezone: string;
  status: 'scheduled' | 'cancelled';
  notes: string | null;
  venue: { name: string; address: string; mapUrl: string | null; notes: string | null } | null;
  outcomes: { id: number; text: string }[];
  trainers: { slot: 'lead' | 'co'; trainer: { id: number; name: string } | null }[];
  attendance: AttendanceStatus | null;
}

export interface PlanterTrainingSchedule {
  semester: { id: number; name: string; planterManualUrl: string | null; timezone: string; completionRequiredSessions: number | null };
  enrollment: { id: number; status: 'enrolled' | 'completed'; completedAt: string | null };
  summary: { attended: number; required: number; totalSessions: number; meetsRequirement: boolean; excused: number; absent: number };
  sessions: PlanterTrainingSession[];
}

export async function fetchMyTrainingSchedule(): Promise<PlanterTrainingSchedule | null> {
  const res = await apiClient.get('/training/my/schedule');
  return res.data.data ?? null;
}

export async function downloadMyTrainingCalendar(): Promise<void> {
  const res = await apiClient.get('/training/my/schedule.ics', { responseType: 'blob' });
  const url = URL.createObjectURL(new Blob([res.data], { type: 'text/calendar' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = '242-training.ics';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const formatTrainingDate = (iso: string, timeZone: string) =>
  new Intl.DateTimeFormat('en-US', { timeZone, weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(iso));

export const formatTrainingWindow = (start: string, end: string, timeZone: string) => {
  const t = (iso: string) => new Intl.DateTimeFormat('en-US', { timeZone, hour: 'numeric', minute: '2-digit' }).format(new Date(iso));
  return `${t(start)}–${t(end)}`;
};
